import { IngredientSideEffectReactionModel } from "./ingredientSideEffectReactionModel";
import { IngredientSideEffectContentModel } from './ingredientSideEffectContentModel';

export class IngredientSideEffectModel {
  public ingredientSideEffectId: number;
  public ingredientSideEffectReactions: Array<IngredientSideEffectReactionModel>;
  public ingredientSideEffectContent: Array<IngredientSideEffectContentModel>;
}